module.exports = __webpack_public_path__ + "img/glassquality_3.60b141cf.png";